<div class="header-main">
  <a href="#/users/edit/me" id="HeaderUserLnk" class="space-h-m"> <i class="fa fa-user"></i> {{ user?.email }} </a>

  <mat-form-field class="form-group selector-small space-h-m">
    <mat-select [(value)]="currentLanguage" id="HeaderLangBtn" (valueChange)="changeLanguage(currentLanguage)">
      <div id="HeaderLangLst">
        <mat-option *ngFor="let language of allLanguages" value="{{ language }}">
          <img [src]="'assets/flags/' + language + '.png'" /> {{ language }}
        </mat-option>
      </div>
    </mat-select>
    <span matPrefix><img [src]="'assets/flags/' + currentLanguage + '.png'" />&#160;</span>
  </mat-form-field>

  <a (click)="logout()" class="cursor" id="HeaderQuitBtn" style="margin: 0 10px 0 10px">
    <i class="fas fa-sign-out-alt"></i>
  </a>
</div>
